<div>
  <!-- TODO: dev-only cluster-id tester. Either gate behind isInternalUser or delete before release. -->
  <!-- <div class="row cluster-test">
    <div class="col-md-6">
      <label for="clusterId">Cluster ID</label>
      <input type="text" class="form-control" id="clusterId" [(ngModel)]="clusterId">
    </div>
    <div class="col-md-6">
      <button class="btn btn-primary" (click)="loadData()">Load Data</button>
    </div>
  </div> -->

  <h4 class="header-title">{{ tab_name }} : Performance History</h4>
  <p class="header-subtitle">
   The graph below displays the performance of a thematic portfolio consisting of the 50 companies most exposed to this technology theme each year, as well as the stage of the technology at each year over the last 10 years. 
   
   The information on this page is created point-in-time for accurate historical evaluation. The graph uses a shorter time period if point in time information regarding the technology isn't available for all 10 years or in case the technology theme is larger than 100k inventions in the last 10 years.
  </p>

  <app-loading-progress
    [active]="showSpinner"
    title="Building performance history"
    [stages]="LOADING_STAGES"
    [estimateSeconds]="90"
    [trackingKey]="tabId + ':perf_history'"
    hint="Broad themes can take a few minutes.">
  </app-loading-progress>

  <div class="alert alert-danger" *ngIf="loadingFailed">
    Failed to load performance history. Please try again or contact
    <a href="mailto:info@quant-ip.com">info&#64;quant-ip.com</a>.
  </div>

  <div class="empty-state" *ngIf="showDataMissing && !showSpinner">
    <i class="bi bi-search empty-state-icon"></i>
    <h5>No Performance History Available</h5>
    <p>{{ dataMissingMessage || 'No performance data is available for this theme.' }}</p>
  </div>

  <ng-container *ngIf="showChart && !showSpinner">
    <div #exportTarget class="chart-card">
      <div class="card-header-row">
        <div class="period-chips" data-html2canvas-ignore="true">
          <button type="button"
            *ngFor="let p of periods"
            class="period-chip"
            [class.active]="activePeriod === p"
            (click)="setPeriod(p)">
            {{ p }}
          </button>
        </div>
        <div class="header-right">
          <div class="stage-legend">
            <span class="stage-chip">
              <span class="dot" style="background:#000"></span>Portfolio Return
            </span>
            <span class="stage-chip" *ngFor="let stage of stageLabels">
              <span class="dot" [style.background]="stage.color"></span>{{ stage.name }}
            </span>
          </div>
          <div class="chart-toolbar" data-html2canvas-ignore="true">
            <button type="button" class="tool-btn" (click)="resetZoom()" title="Reset zoom">
              <i class="bi bi-arrow-counterclockwise"></i>
            </button>
            <button type="button" class="tool-btn" (click)="downloadPng()" title="Download PNG">
              <i class="bi bi-download"></i>
            </button>
          </div>
        </div>
      </div>

      <p class="zoom-hint" data-html2canvas-ignore="true">Drag to zoom • Shift + drag to pan  • Double-click to reset</p>

      <div class="chart-container">
        <canvas baseChart
          [type]="'line'"
          [data]="chartjsData"
          [options]="chartjsOptions"
          (dblclick)="resetZoom()">
        </canvas>
      </div>
    </div>
  </ng-container>
</div>
